import React from 'react';
import {DateTime} from "luxon";
import {dateValue, inputFormat, today} from "services/insight";

// Helpers ----

function handleChange(value: string, callback: (date: DateTime) => void) {
  const dateTime = DateTime.fromISO(value || DateTime.now().toISODate());

  // If dateTime object is valid, run the callback
  if (dateTime.isValid) callback(dateTime);
}

// Types ----

type Props = {
    id: string
    name: string
    label?: string
    value: DateTime
    onChange: (date: DateTime) => any
    minDate?: DateTime
    maxDate?: DateTime
}

// Component ----

function DateInput({id, label, minDate, maxDate, name, onChange, value}: Props) {
    return (
        <div className='flex flex-col gap-1'>
            {label &&
              <label htmlFor={id} className="block text-sm font-medium text-gray-700">{label}</label>
            }
            <input
                id={id}
                type="date"
                name={name}
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand focus:ring-brand sm:text-sm"
                min={minDate ? minDate.toFormat(inputFormat) : undefined}
                max={(maxDate ?? today).toFormat(inputFormat)}
                value={dateValue(value)}
                onChange={event => handleChange(event.target.value, onChange)}
            />
        </div>
    );
}

export default DateInput;